import axiosClient from '../../../../api/axiosClient.js';

export async function updateUserAlias({id, alias, email, username}) {
  const { data } = await axiosClient.patch(`/api/users/users/${id}/`, {
    alias_name: alias
  });

  return data;
}

export async function resetPassword({username, oldPassword, newPassword}) {
  const { data } = await axiosClient.post(`/users/change-password/`, {
    username,
    old_pass: oldPassword,
    new_pass: newPassword
  });

  return data;
}